import { Button } from "@blueprintjs/core"
import StatusIcon from "components/Atoms/StatusIcon"
import { TRANSACTION_STATUS } from "data/static.items"
import {
  TransactionStatus,
  useChangeTransactionStatusMutation,
} from "generated/graphql"
import React from "react"
import { ApolloErrorToast } from "utils/AppToaster"

type EditReconcileStatusType = {
  status?: string
  /**
   * transaction.transactionId (uuid)
   */
  uuid?: string
}
const EditReconcileStatus = ({ status, uuid }: EditReconcileStatusType) => {
  const [update, { loading }] = useChangeTransactionStatusMutation({
    onError: ApolloErrorToast,
  })
  const statusObj = TRANSACTION_STATUS.find(e => e.id === status)

  function accept() {
    // Can only accept if the transaction is in Authorized stage
    if (statusObj.id === TransactionStatus.AUT) {
      update({
        variables: {
          transactionIds: [uuid],
          // Reconcile the transaction
          status: TransactionStatus.RCN,
        },
      })
    }
  }

  function reject() {
    // Can only reject if the transaction is in Authorized status
    if (statusObj.id === TransactionStatus.AUT) {
      update({
        variables: {
          transactionIds: [uuid],
          // Reject the transaction (Reconcile Failed)
          status: TransactionStatus.RCF,
        },
      })
    }
  }

  // Only able to perform actions when the status is 'Created'
  if (statusObj.id === TransactionStatus.AUT) {
    return (
      <>
        <Button
          loading={loading}
          onClick={accept}
          className="mr-2 rounded-full"
          intent="success"
          icon="tick"
        />
        <Button
          className="rounded-full"
          loading={loading}
          onClick={reject}
          intent="danger"
          icon="cross"
        />
      </>
    )
  }

  return (
    <StatusIcon
      condition={statusObj.id}
      values={{
        [TransactionStatus.AUT]: {
          intent: "success",
          text: "Confirmed",
          tooltip: "Transaction has been confirmed",
        },
        [TransactionStatus.FAL]: {
          intent: "danger",
          text: "Rejected",
          tooltip: "Transaction has been rejected",
        },
        [TransactionStatus.RCF]: {
          intent: "danger",
          text: "Rejected",
          tooltip: "Reconciliation has been rejected",
        },
        [TransactionStatus.CRT]: {
          intent: "primary",
          text: "Pending",
          tooltip: "Please wait till the transaction is confirmed or rejected",
        },
        [TransactionStatus.RCN]: {
          intent: "success",
          text: "Reconciled",
          tooltip: "Transaction has been reconciled successfully!",
        },
      }}
    />
  )
}

export default EditReconcileStatus
